import axios from './configAxios';

export const postToRegistaration = async (requestData) => {
  return await axios.post('/client/registration/', requestData);
};
